const processClasses = [
    {
        encodedLabel: 0,
        decodedLabel: "ground_gravel",
        buildingElement: "ground",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 1,
        decodedLabel: "ground_concrete_bucket",
        buildingElement: "ground",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 2,
        decodedLabel: "ground_concrete_pump",
        buildingElement: "ground",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 3,
        decodedLabel: "foundation_slab_formwork",
        buildingElement: "foundation",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 4,
        decodedLabel: "foundation_stripe_formwork",
        buildingElement: "foundation",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 5,
        decodedLabel: "foundation_point_formwork",
        buildingElement: "foundation",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 6,
        decodedLabel: "foundation_elevator_formwork",
        buildingElement: "foundation",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 7,
        decodedLabel: "foundation_slab_rebar",
        buildingElement: "foundation",
        processElement: "reinforce",
        processElementLabel: "reinforce",
    },
    {
        encodedLabel: 8,
        decodedLabel: "foundation_stripe_rebar",
        buildingElement: "foundation",
        processElement: "reinforce",
        processElementLabel: "reinforce",
    },
    {
        encodedLabel: 9,
        decodedLabel: "foundation_point_rebar",
        buildingElement: "foundation",
        processElement: "reinforce",
        processElementLabel: "reinforce",
    },
    {
        encodedLabel: 10,
        decodedLabel: "foundation_elevator_rebar",
        buildingElement: "foundation",
        processElement: "reinforce",
        processElementLabel: "reinforce",
    },
    {
        encodedLabel: 11,
        decodedLabel: "foundation_slab_concrete_bucket",
        buildingElement: "foundation",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 12,
        decodedLabel: "foundation_slab_concrete_pump",
        buildingElement: "foundation",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 13,
        decodedLabel: "foundation_stripe_concrete_bucket",
        buildingElement: "foundation",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 14,
        decodedLabel: "foundation_stripe_concrete_pump",
        buildingElement: "foundation",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 15,
        decodedLabel: "foundation_point_concrete_bucket",
        buildingElement: "foundation",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 16,
        decodedLabel: "foundation_point_concrete_pump",
        buildingElement: "foundation",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 17,
        decodedLabel: "foundation_elevator_concrete_bucket",
        buildingElement: "foundation",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 18,
        decodedLabel: "foundation_elevator_concrete_pump",
        buildingElement: "foundation",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 19,
        decodedLabel: "foundation_slab_insulation",
        buildingElement: "foundation",
        processElement: "sheath",
        processElementLabel: "sheath",
    },
    {
        encodedLabel: 20,
        decodedLabel: "foundation_stripe_insulation",
        buildingElement: "foundation",
        processElement: "sheath",
        processElementLabel: "sheath",
    },
    {
        encodedLabel: 21,
        decodedLabel: "foundation_point_insulation",
        buildingElement: "foundation",
        processElement: "sheath",
        processElementLabel: "sheath",
    },
    {
        encodedLabel: 22,
        decodedLabel: "foundation_elevator_insulation",
        buildingElement: "foundation",
        processElement: "sheath",
        processElementLabel: "sheath",
    },
    {
        encodedLabel: 23,
        decodedLabel: "ceiling_element_semi",
        buildingElement: "ceiling",
        processElement: "prefab",
        processElementLabel: "prefab",
    },
    {
        encodedLabel: 24,
        decodedLabel: "ceiling_element_full",
        buildingElement: "ceiling",
        processElement: "prefab",
        processElementLabel: "prefab",
    },
    {
        encodedLabel: 25,
        decodedLabel: "ceiling_beam",
        buildingElement: "ceiling",
        processElement: "prefab",
        processElementLabel: "prefab",
    },
    {
        encodedLabel: 26,
        decodedLabel: "ceiling_balcony",
        buildingElement: "ceiling",
        processElement: "prefab",
        processElementLabel: "prefab",
    },
    {
        encodedLabel: 27,
        decodedLabel: "ceiling_stairs",
        buildingElement: "ceiling",
        processElement: "prefab",
        processElementLabel: "prefab",
    },
    {
        encodedLabel: 28,
        decodedLabel: "ceiling_default_formwork",
        buildingElement: "ceiling",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 29,
        decodedLabel: "ceiling_edge_formwork",
        buildingElement: "ceiling",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 30,
        decodedLabel: "ceiling_underbeams_formwork",
        buildingElement: "ceiling",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 31,
        decodedLabel: "ceiling_default_rebar",
        buildingElement: "ceiling",
        processElement: "reinforce",
        processElementLabel: "reinforce",
    },
    {
        encodedLabel: 32,
        decodedLabel: "ceiling_default_tubing",
        buildingElement: "ceiling",
        processElement: "reinforce",
        processElementLabel: "reinforce",
    },
    {
        encodedLabel: 33,
        decodedLabel: "ceiling_underbeams_rebar",
        buildingElement: "ceiling",
        processElement: "reinforce",
        processElementLabel: "reinforce",
    },
    {
        encodedLabel: 34,
        decodedLabel: "ceiling_default_concrete_bucket",
        buildingElement: "ceiling",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 35,
        decodedLabel: "ceiling_default_concrete_pump",
        buildingElement: "ceiling",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 36,
        decodedLabel: "ceiling_underbeams_concrete_bucket",
        buildingElement: "ceiling",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 37,
        decodedLabel: "ceiling_underbeams_concrete_pump",
        buildingElement: "ceiling",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 38,
        decodedLabel: "ceiling_default_insulation",
        buildingElement: "ceiling",
        processElement: "sheath",
        processElementLabel: "sheath",
    },
    {
        encodedLabel: 39,
        decodedLabel: "wall_brickwork",
        buildingElement: "wall",
        processElement: "prefab",
        processElementLabel: "brickwork",
    },
    {
        encodedLabel: 40,
        decodedLabel: "wall_brick_outline",
        buildingElement: "wall",
        processElement: "prefab",
        processElementLabel: "brickwork",
    },
    {
        encodedLabel: 41,
        decodedLabel: "wall_default_element",
        buildingElement: "wall",
        processElement: "prefab",
        processElementLabel: "prefab",
    },
    {
        encodedLabel: 42,
        decodedLabel: "wall_column_element",
        buildingElement: "wall",
        processElement: "prefab",
        processElementLabel: "prefab",
    },
    {
        encodedLabel: 43,
        decodedLabel: "wall_wetcell",
        buildingElement: "wall",
        processElement: "prefab",
        processElementLabel: "prefab",
    },
    {
        encodedLabel: 44,
        decodedLabel: "wall_default_formwork",
        buildingElement: "wall",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 45,
        decodedLabel: "wall_column_formwork",
        buildingElement: "wall",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 46,
        decodedLabel: "wall_attica_formwork",
        buildingElement: "wall",
        processElement: "support",
        processElementLabel: "support",
    },
    {
        encodedLabel: 47,
        decodedLabel: "wall_default_rebar",
        buildingElement: "wall",
        processElement: "reinforce",
        processElementLabel: "reinforce",
    },
    {
        encodedLabel: 48,
        decodedLabel: "wall_column_rebar",
        buildingElement: "wall",
        processElement: "reinforce",
        processElementLabel: "reinforce",
    },
    {
        encodedLabel: 49,
        decodedLabel: "wall_attica_rebar",
        buildingElement: "wall",
        processElement: "reinforce",
        processElementLabel: "reinforce",
    },
    {
        encodedLabel: 50,
        decodedLabel: "wall_default_concrete_bucket",
        buildingElement: "wall",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 51,
        decodedLabel: "wall_default_concrete_pump",
        buildingElement: "wall",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 52,
        decodedLabel: "wall_column_concrete_bucket",
        buildingElement: "wall",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 53,
        decodedLabel: "wall_column_concrete_pump",
        buildingElement: "wall",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 54,
        decodedLabel: "wall_attica_concrete_bucket",
        buildingElement: "wall",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 55,
        decodedLabel: "wall_attica_concrete_pump",
        buildingElement: "wall",
        processElement: "concrete",
        processElementLabel: "concrete",
    },
    {
        encodedLabel: 56,
        decodedLabel: "roof_rafters",
        buildingElement: "roof",
        processElement: "prefab",
        processElementLabel: "prefab",
    },
    {
        encodedLabel: 57,
        decodedLabel: "roof_insulation",
        buildingElement: "roof",
        processElement: "sheath",
        processElementLabel: "sheath",
    },
    {
        encodedLabel: 58,
        decodedLabel: "roof_tile",
        buildingElement: "roof",
        processElement: "sheath",
        processElementLabel: "sheath",
    },
    {
        encodedLabel: 59,
        decodedLabel: "roof_metal",
        buildingElement: "roof",
        processElement: "sheath",
        processElementLabel: "sheath",
    },
];
export default processClasses;
//# sourceMappingURL=ProcessClasses.js.map